<template>
  <v-app>
    <v-app-bar app color="bleak" dark>
      <div class="d-flex align-center">
        <v-img src="./assets/logo.svg" contain width="40" transition="scale-transition" />

        <h2 style="margin: 10px">
          WM线路检测
        </h2>
      </div>

      <v-spacer />

      <h2 v-if="id != 0" style="color: gold">ID: {{ id }}</h2>
    </v-app-bar>

    <v-content>
      <v-card :loading="user_agent.ua==''" :width="card_width" style="float: left; margin: 10px">
        <v-form>
          <v-text-field label="OS" :value="user_agent.os" readonly style="margin: 10px" />
          <v-text-field label="Device" :value="user_agent.device" readonly style="margin: 10px" />
          <v-text-field label="Browser" :value="user_agent.browser" readonly style="margin: 10px" />
          <v-textarea label="User Agent" :value="user_agent.ua" readonly style="margin: 10px" />
        </v-form>
      </v-card>

      <v-card :loading="ip_info.ip==''" :width="card_width" style="float: left; margin: 10px">
        <v-form>
          <v-text-field label="IP" :value="ip_info.ip" readonly style="margin: 10px" />
          <v-text-field label="Country" :value="ip_info.country" readonly style="margin: 10px" />
          <v-text-field label="City" :value="ip_info.city" readonly style="margin: 10px" />
          <v-text-field label="Region" :value="ip_info.region" readonly style="margin: 10px" />
          <v-text-field label="ISP" :value="ip_info.isp" readonly style="margin: 10px" />
        </v-form>
      </v-card>

      <v-card v-for="item in line.websocket" :key="item.id" :loading="item.response.length < test_count" :width="card_width" style="float: left; margin: 10px">
        <v-card-title><h5>{{ item.id }}</h5></v-card-title>
        <v-divider />
        <div style="float: left">
          <v-list dense>
            <v-timeline v-for="(res, index) in item.response" :key="index" dense>
              <v-timeline-item small fill-dot :color="httpResponseColor(res)">{{ res !== 'timeout' ? res + ' ms' : 'timeout' }}</v-timeline-item>
            </v-timeline>
          </v-list>
        </div>
      </v-card>

      <v-card v-for="item in line.http" :key="item.id" :loading="item.response.length < test_count || item.bandwidth.length < test_count" :width="card_width" style="float: left; margin: 10px">
        <v-card-title><h5>{{ item.id }}</h5></v-card-title>
        <v-divider />
        <div style="float: left">
          <v-list dense>
            <v-timeline v-for="(res, index) in item.response" :key="index" dense>
              <v-timeline-item small fill-dot :color="httpResponseColor(res)">{{ res !== 'timeout' ? res + ' ms' : 'timeout' }}</v-timeline-item>
            </v-timeline>
          </v-list>
        </div>
        <div style="float: left">
          <v-list dense>
            <v-timeline v-for="(bw, index) in item.bandwidth" :key="index" dense>
              <v-timeline-item small fill-dot :color="httpBandwidthColor(bw)">{{ httpBandwidthLevel(bw) }}</v-timeline-item>
            </v-timeline>
          </v-list>
        </div>
      </v-card>
    </v-content>

    <v-dialog v-model="consent" persistent max-width="500">
      <v-card>
        <v-card-title>Use WM line detection service?</v-card-title>
        <v-card-text>
          This page is only used for WM line detection.<br> Press the Agree button to start the test<br> After the completion, return the ID to the customer service.
          <br><br>
          此网页仅用于WM线路检测用<br>按下同意后开始检测, 完成后回报ID給客服人员.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" dark @click="start()">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :multi-line="true" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
  </v-app>
</template>

<script>
import UAParser from 'ua-parser-js'
import axios from 'axios'

export default {
  name: 'App',

  data: () => ({
    timeout: 9999,
    test_count: 3,

    id: 0,
    consent: false,
    card_width: 0,
    config: {},

    test_time: 0,
    domain: '',
    ip_info: {
      ip: '',
      country: '',
      city: '',
      region: '',
      isp: '',
    },
    user_agent: {
      ua: '',
      os: '',
      device: '',
      browser: '',
    },
    line: {
      websocket: [],
      http: [],
    },

    snackbar: {
      show: false,
      color: '',
      message: '',
      timeout: 0,
    },
  }),

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.search = new URLSearchParams(window.location.search)
    this.test_time = Date.now()
    this.consent = true
    this.domain = this.search.get('domain')

    axios.get('/api/config')
      .then((res) => {
        this.config = res.data
        for (let ws of res.data.websocket) {
          this.line.websocket.push({
            id: ws.id,
            url: ws.url,
            response: [],
          })
        }
        for (let http of res.data.http) {
          this.line.http.push({
            id: http.id,
            url: this.user_agent.device.indexOf('iPhone') === -1 ? http.url : http.url2,
            response: [],
            bandwidth: [],
          })
        }
      })
      .catch((err) => {
        console.error(err.response || err)
      })
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() {
      console.info(`windows resize to ${window.innerWidth}x${window.innerHeight}`)
      this.card_width = Math.min(window.innerWidth-20, 450)
    },

    start() {
      this.consent = false

      this.snackbar.color = 'blue'
      this.snackbar.message = 'testing...'
      this.snackbar.timeout = 0
      this.snackbar.show = true

      this.initUserAgent()
      this.initIpinfo()

      setTimeout(() => {
        for (let http of this.line.http) {
          this.testResponse(http)
        }
        this.testBandwidth()
        this.testWebsocket()
      }, 1000)
    },

    initUserAgent() {
      let ua = new UAParser().getResult()
      console.info('user agent:', ua)
      this.user_agent.ua = ua.ua
      this.user_agent.os = `${ua.os.name} ${ua.os.version}`
      this.user_agent.device = ua.os.name == 'Windows' ? 'PC' : `${ua.device.model} (${ua.device.vendor})`
      this.user_agent.browser = `${ua.browser.name} ${ua.browser.version}`
      if (ua.cpu.architecture) this.user_agent.os += ` (${ua.cpu.architecture})`
    },

    initIpinfo() {
      axios.get('/api/ip_info')
        .then((res) => {
          let ip_info = res.data.results
          console.info('ip_info', ip_info)
          this.ip_info.ip = ip_info.ip
          this.ip_info.country = `${ip_info.country_long} (${ip_info.country_short})`
          this.ip_info.city = ip_info.city
          this.ip_info.region = ip_info.region
          this.ip_info.isp = ip_info.isp
        })
        .catch((err) => {
          console.error(err.response || err)
          setTimeout(() => {
            this.initIpinfo()
          }, 5000)
        })
    },

    testWebsocket() {
      let sub_func = (item) => {
        let time_start = new Date()
        let ws = new WebSocket(item.url)
        ws.onopen = () => {
          let time_end = new Date()
          let time_total = (time_end - time_start)
          item.response.push(time_total)
          ws.close()
          if (item.response.length < this.test_count) {
            setTimeout(() => {
              sub_func(item)
            }, 1000)
          } else {
            ws.close()
          }
        }
      }

      for (let ws of this.line.websocket) {
        if (ws.response.length < this.test_count) {
          sub_func(ws)
          //break
        }
      }
    },

    testResponse(line) {
      let time_start = new Date()
      axios.get(`${line.url}?t=${Math.random()}`, {
          timeout: this.timeout,
        })
        .then((res) => {
          let time_end = new Date()
          let time_total = (time_end - time_start)
          line.node = res.headers['x-node']
          line.response.push(time_total)
          if (line.response.length < this.test_count) {
            setTimeout(() => {
              this.testResponse(line)
            }, 1000)
          }
        })
        .catch((err) => {
          console.error(err.response || err)
          line.response.push('timeout')
            if (line.response.length < this.test_count) {
              setTimeout(() => {
                this.testResponse(line)
              }, 1000)
            }
          })
        },

    testBandwidth() {
      let sub_func = (line) => {
        let file_size = this.config.cdn_jpg_size / 1024 //kb
        let file_url = `${line.url}?t=${Math.random()}`
        let time_start = new Date()

        axios.get(file_url, {
            timeout: this.timeout,
          })
          .then(() => {
            let time_end = new Date()
            let time_total = (time_end - time_start) / 1000 //second
            let bandwidth = Math.round(file_size / time_total) * 8 // kb/s
            line.bandwidth.push(bandwidth)
            setTimeout(() => {
              this.testBandwidth()
            }, 1000)
          })
          .catch((err) => {
            console.error(err.response || err)
            line.bandwidth.push(0)
            setTimeout(() => {
              this.testBandwidth()
            }, 1000)
          })
      }

      let step1 = () => {
        let count = 0
        for (let line of this.line.http) {
          if (line.response.length === this.test_count) {
            count += 1
          }
        }
        if (count === this.line.http.length) {
          step2()
        } else {
          setTimeout(() => {
            step1()
          }, 1000)
        }
      }

      let step2 = () => {
        let count = 0
        for (let line of this.line.http) {
          if (line.bandwidth.length < this.test_count) {
            sub_func(line)
            break
          } else {
            count += 1
          }
        }
        if (count === this.line.http.length) {
          step3()
        }
      }

      let step3 = () => {
        axios.post('/api/upload', {
            domain: this.domain,
            test_time: this.test_time,
            user_agent: this.user_agent,
            ip_info: this.ip_info,
            websocket: this.line.websocket,
            http: this.line.http,
          })
          .then((res) => {
            this.id = res.data.id
            this.snackbar.color = 'green'
            this.snackbar.message = `Return success (回報成功), ID: ${this.id}`
            this.snackbar.show = true
          })
          .catch((err) => {
            console.error(err.response || err)
            this.snackbar.color = 'red'
            this.snackbar.message = `Return failed, retry after 5 seconds. 回報失敗, 5秒後重試`
            this.snackbar.timeout = 4500
            this.snackbar.show = true
            setTimeout(() => {
              this.testBandwidth()
            }, 3000)
        })
      }

      step1()
    },

    httpResponseColor(value) {
      if (value < 150) {
        return 'green'
      } else if (value < 500) {
        return 'blue'
      } else if (value < 1000) {
        return 'yellow'
      } else {
        return 'red'
      }
    },

    httpBandwidthColor(value) {
      if (value < 500) {
        return 'red'
      } else if (value < 1000) {
        return 'yellow'
      } else if (value < 3000) {
        return 'blue'
      } else {
        return 'green'
      }
    },

    httpBandwidthLevel(value) {
      if (value <= 0) {
        return '0'
      } else if (value < 1024) {
        return `${value} K`
      } else if (value < 1024*1024) {
        value /= 1024
        return `${value.toFixed(2)} M`
      } else {
        value /= (1024*1024)
        return `${value.toFixed(2)} G`
      }
    }
  },
};
</script>
